<template>
    <div>
        <!-- input file hidden -->
        <input type="file" name="myfile" style="display:none;" ref="myfile" @change="uploadFile()">

        <div  v-if="theme == 'contracts'">
          <a @click="uploadModal()"><img :src="StorageURL + '/img/icons/UPLOAD-ICON.png'" class="rounded" style="width: 60px !important"></a>
        </div>
        <!-- Admin Theme -->
        <div class="card" v-else-if="theme != 'basic'">
            <div class="card-header">
                 <div class="row">
                    <div class="col-md-1">
                        <span class="btn-group-sm">
                            <button type="button" class="btn bmd-btn-fab"
                                v-bind:class="{'btn-success': (src != null && src != ''), 'btn-secondary': !(src != null && src != '')}">
                                <em class="material-icons" v-if="(src != null && src != '')">check</em>
                            </button>
                        </span>
                    </div>
                    <div class="col-md-8">{{title}}</div>
                    <div class="col-md-3">
                        <button class="btn btn-secondary bmd-btn-fab float-right"
                            data-toggle="tooltip" data-placement="top" title="Abrir archivo"
                            v-if="src != null && src != ''"
                            @click="zoomModal()">
                            <em class="material-icons">open_in_new</em>
                        </button>
                        <button class="btn btn-secondary bmd-btn-fab float-right"
                            data-toggle="tooltip" data-placement="top" title="Agregar / Actualizar"
                            @click="uploadModal()">
                            <em class="material-icons">attach_file</em>
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <!-- Portal Theme -->
        <div v-else>
            <div class="file-input-container">
                <div class="btn-group btn-group-justified" role="group">
                    <button type="button" class="btn btn-default btn-sm btn-upload-full" v-if="src == '' || src == null" @click="uploadModal()"><em class="material-icons" v-if="!noIcons">cloud_upload</em> Selecciona un documento...</button>
                    <button type="button" class="btn btn-default btn-sm btn-upload" v-if="src != '' && src != null" @click="uploadModal()"><em class="material-icons" v-if="!noIcons">cloud_upload</em> Actualizar</button>
                    <button type="button" class="btn btn-default btn-sm btn-download" v-if="src != '' && src != null" @click="zoomModal()"><em class="material-icons" v-if="!noIcons">cloud_download</em> Ver</button>
                </div>
            </div>
        </div>




        <!-- Modal -->
        <div class="modal fade" ref="zoomModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true" v-if="showDialog">
            <div class="modal-dialog modal-lg" role="document">
                <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="exampleModalLabel">{{title}}</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <img :src="srcbind" v-if="filetype == 'image' || filetype == 'xml'" class="img-fluid">
                    <iframe :src="srcbind" frameborder="0" height="450px" v-if="filetype == 'pdf'"></iframe>
                </div>
                <div class="modal-footer">
                    <a-secure :href="downloadUrl" class="btn btn-primary" v-if="!is_public">Descargar</a-secure>
                    <a-secure :href="path + src" class="btn btn-primary" v-else download>Descargar</a-secure>
                    <button type="button" class="btn btn-secondary" data-dismiss="modal">Cerrar</button>
                </div>
                </div>
            </div>
        </div>

    </div>
</template>
<script>
    import { mapState } from 'vuex'
    import ASecure from "@components/utils/aSecure";

    export default {
      components: {ASecure},
      props:["title", "path", "src", "theme", "projectId", "userId", "type", "field", "rl", 'new', 'is_public','factura_data', "noIcons", "popup"],
        computed: {
            downloadUrl() {
                let uri = this.srcbind.replace("/storage/private/", '');
                return `/storage/private/download/${uri}`;
            },
            ...mapState('auth', ['user']),
        },
        watch: {
            src(){
                if(this.theme == 'basic' || this.is_public == true){
                    this.srcbind = `${this.path}/${this.src}?access_token=${this.user.access_token}`;
                }else {
                    this.srcbind = `${this.StorageURL}/${this.path}/${this.src}/?access_token=${this.user.access_token}`;
                }
                this.checkTypeFile();
            }
        },
        data:() => ({
            showDialog: false,
            srcbind: "default.jpg",
            filetype: 'image',
            popupbind: false
        }),
        mounted() {
            if(this.theme == 'basic' || this.is_public == true){
                this.srcbind = `${this.StorageURL}/${this.path}/${this.src}?access_token=${this.user.access_token}`;
            }else {
                this.srcbind = `${this.StorageURL}/${this.path}/${this.src}/?access_token=${this.user.access_token}`;
            }
            this.popupbind = (typeof this.popup == "undefined") ? false : true;
            this.checkTypeFile();
        },
        methods: {
            zoomModal() {
                if(this.popupbind) {
                    window.open(this.srcbind, "_blank", "height=800,width=1130,top=100,left=100")
                } else {
                    if(this.srcbind.match("xml.*")) {
                        window.open(this.srcbind, "_blank");
                    } else {
                        this.showDialog = true
                        setTimeout(() => {
                            $(this.$refs["zoomModal"]).modal("show")
                        }, 500)
                    }
                }
            },
            checkTypeFile() {
                if(this.srcbind != "" && this.srcbind != null && this.srcbind != "undefined") {
                    if(this.srcbind.match("pdf.*") || this.srcbind.match("PDF.*"))
                        this.filetype = "pdf"
                    else if(this.srcbind.match("image.*"))
                        this.filetype = "image"
                    else if(this.srcbind.match("xml.*") || this.srcbind.match("XML.*")) {
                        this.filetype = "xml"
                        //this.srcbind = "xml-image-default.png"
                    }

                }
            },
            uploadModal() {
                $(this.$refs.myfile).click()
            },
            uploadFile() {
                let data = new FormData();
                data.append("myfile", $(this.$refs.myfile)[0].files[0]);
                if(this.projectId != undefined && this.projectId != "")
                    data.append("project_id", this.projectId);
                    data.append("user_id", this.userId);
                    data.append("field", this.field);
                    data.append("rl", (this.rl != undefined) ? this.rl : false);
                    data.append("new", this.new);
                if(this.factura_data != undefined && this.factura_data != null){
                    data.append("factura_id", this.factura_data.factura_id);
                    data.append("invoice_type", this.factura_data.invoice_type);
                    data.append("facturapdf", this.factura_data.facturapdf);
                    data.append("facturaxml", this.factura_data.facturaxml);
                }
                this.$emit('uploading', 1)
                axios.post("/admin/document/upload", data, { "Content-Type": "multipart/form-data" })
                .then((res) => {
                    //this.src = res.data.image
                    this.$emit('uploaded', res.data.image)
                    this.srcbind = this.path + res.data.image
                    this.checkTypeFile();
                });

            }
        }
    }
</script>
<style scoped>
.btn-download {
    width: 30%;
    border: 1px solid #000;
}
.btn-upload {
    width: 70%;
    border: 1px solid #000;
}
.btn-upload-full {
    width: 100%;
    border: 1px solid #000;
}
.card-header .bmd-btn-fab {
    min-width: 1.5rem;
    width: 1.5rem;
    height: 1.5rem;
}
.card { margin-bottom: 5px; }
.card-header {
    background-color: #e0e0e0;
}
</style>
